import { useQuery } from "@tanstack/react-query";
import { PERMISSION_GROUPS_QUERY_KEY } from "../constants";
import { PoliciesService } from "../services/policies.service";

export const useSearchPermissionGroups = (payload: {
  filterBy: {
    brandOrganisationId: string;
  };
  limit: number;
  pageNo: number;
  searchQuery?: string;
}) => {
  const queryKey = [
    ...PERMISSION_GROUPS_QUERY_KEY,
    payload.filterBy?.brandOrganisationId,
    payload,
  ];
  const {
    data: permissionGroups,
    isFetching: isFetchingPermissionGroups,
    error: permissionGroupsError,
    isSuccess: isSuccessPermissionGroups,
  } = useQuery({
    queryKey: queryKey,
    queryFn: () => PoliciesService.searchPermissionGroups(payload),
    enabled: !!payload.filterBy?.brandOrganisationId,
  });
  return {
    permissionGroups,
    isFetchingPermissionGroups,
    permissionGroupsError,
    isSuccessPermissionGroups,
    queryKey,
  };
};
